import type { LightingAnswers } from '~/types/lightingAdvisor';

export function parseLightFunctionAnswers(raw: unknown): string[] {
  if (Array.isArray(raw)) {
    return raw.map((value: unknown) => String(value)).filter(Boolean);
  }
  if (typeof raw === 'string' && raw.trim() !== '') {
    if (raw.startsWith('[')) {
      try {
        const parsed = JSON.parse(raw) as unknown;
        if (Array.isArray(parsed)) {
          return parsed.map((value: unknown) => String(value)).filter(Boolean);
        }
      } catch {
        // comma-separated fallback
      }
    }
    return raw
      .split(',')
      .map((value: string) => value.trim())
      .filter(Boolean);
  }
  return [];
}

export function hasCompleteFlagAnswers(answers: LightingAnswers): boolean {
  return Boolean(
    answers.a2s1q1 &&
    answers.a2s1q3 &&
    answers.a2s2q1 &&
    answers.a2s2q2_length &&
    answers.a2s2q2_width &&
    answers.a2s3q1
  );
}
